import React from 'react';

const Social = () => {
    return (
        <div className="home__social">
            {/* <a href="https://x.com/Gonza_villalba8" className="home__social-icon" target="_blank">
                <i class="uil uil-twitter-alt"></i>
            </a>

            <a href="https://www.linkedin.com/in/gonzalo-emiliano-villalba/" className="home__social-icon" target="_blank">
                <i class="uil uil-linkedin"></i>
            </a>
            
            <a href="https://github.com/gonzavillalba02" className="home__social-icon" target="_blank">
                <i class="uil uil-github-alt"></i>
            </a> */}
        </div>
    )
}

export default Social;